import { funAcortarText } from "../../../../../global/utils/text";
import { useEffect, useState } from "react";
import CorazonIcon from "../../../../assets/images/generico/CorazonIcon";
import { ValidaTurnoCard } from "./localStyle";
import { getLocalStorage } from "global/utils/safeJsonParse";

const CardBlueHeart = ({ turnoTitle, medico, pasoActual, pasoTotal }) => {
  // Aplica acortado sólo en mobile
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false,
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const titleShown = isMobile ? funAcortarText(20, turnoTitle) : turnoTitle;
  const medicoShown = isMobile ? funAcortarText(20, medico) : medico;
  const idTerminal = getLocalStorage("idTerminal");

  return (
    <ValidaTurnoCard $isTerminal={idTerminal}>
      <CorazonIcon
        color={"var(--color-white)"}
        clase="resumencard-corazonIcon"
      />
      <div className="number">
        <span>TURNO</span>
        <span>
          {" "}
          {pasoActual} de {pasoTotal}:{" "}
        </span>
      </div>
      <div className="text">
        <span>{titleShown}</span>
        <span>{medicoShown}</span>
      </div>
    </ValidaTurnoCard>
  );
};

export default CardBlueHeart;
